import { initNavigation } from './modules/navigation.js';
import { initReviewRatings } from './modules/review-ratings.js';
import { initFaq } from './modules/faq.js';
import { initDocumentFilters } from './modules/document-filters.js';
import { initRegulatoryPopup } from './modules/regulatory-popup.js';
import { initRequestForm } from './modules/request-form.js';

const ready = (callback) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
    return;
  }

  callback();
};

ready(() => {
  document.documentElement.classList.add('is-ready');

  initNavigation();
  initReviewRatings();
  initFaq();
  initDocumentFilters();
  initRegulatoryPopup();
  initRequestForm();
});
